import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import type { TamperEventSettingsState } from "Interfaces";

const initialState: TamperEventSettingsState = {
	email: false,
	alarmOut: false,
	audioAlarm: false,
	interval: 5,
	recording: false,
	redBlueLight: false,
	snapshot: false,
	whiteLight: false,
	ftp: false
};

const setTamperEventReducer = (state: TamperEventSettingsState, action: PayloadAction<TamperEventSettingsState>) => {
	return action.payload;
};

const getTamperEvent = (state: TamperEventSettingsState) => {
	return state;
};

const tamperEventSlice = createAppSlice({
	initialState,
	name: "tamperEvent",
	reducers: {
		setTamperEventAction: setTamperEventReducer
	},
	selectors: {
		selectTamperEvent: getTamperEvent
	}
});

export default tamperEventSlice;

export const { setTamperEventAction } = tamperEventSlice.actions;
export const { selectTamperEvent } = tamperEventSlice.selectors;
